import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { serverLink } from "../../../resources/url";
import { Link } from "react-router-dom";
import PageHeader from "../../common/pageheader/pageheader";
import Loader from "../../common/loader/loader";

const PaymentHistory = ({ userData, paymentHistory }) => {
    const [history, setHistory] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getPaymentHistory();
        // document.body.classList.add("mini-sidebar");

        // Remove class when component unmounts
        // return () => {
        //      document.body.classList.remove("mini-sidebar");
        // };
    }, []);

    const getPaymentHistory = async () => {
        const sendData = { student_id: userData.student_id };

        if (paymentHistory.length > 0) {
            setHistory(paymentHistory);
            setIsLoading(false);
        } else {
            try {
                const result = await axios.post(`${serverLink}payment/payment_history`, sendData, userData.token);
                setIsLoading(false);
                if (result.data.length > 0) {
                    setHistory(result.data);
                }
            } catch (error) {
                console.log("ERROR FETCHING RECORD", error);
            }
        }
    };

    const currencyConverter = (amount) => {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "NGN",
        }).format(amount);
    };

    const formatDate = (date) => {
        if (date !== null) {
            const user_date = new Date(date);
            const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            return `${user_date.getDate()}-${monthNames[user_date.getMonth()]}-${user_date.getFullYear()} ${user_date.getHours()}:${user_date.getMinutes()}:${user_date.getSeconds()}`;
        } else {
            return "--";
        }
    };

    return (
        <div>
            {/*<ul className="nav nav-tabs mb-3" role="tablist">*/}
            {/*    <li className="nav-item">*/}
            {/*        <Link className="nav-link" to="/portal/payment/dashboard" aria-selected="false">Dashboard</Link>*/}
            {/*    </li>*/}
            {/*    <li className="nav-item">*/}
            {/*        <Link className="nav-link"  to="/portal/payment/pay-now" aria-selected="false">Pay Now</Link>*/}
            {/*    </li>*/}
            {/*    <li className="nav-item">*/}
            {/*        <Link className="nav-link active"  to="/portal/payment/history" aria-selected="true">Payment History</Link>*/}
            {/*    </li>*/}
            {/*</ul>*/}
            {/*<hr className="bg-dark"/>*/}
            <PageHeader
                title={"Payment History"}
                items={["Payment", "Payment History"]}
            />

            <div className="d-grid gap-3">
                {isLoading ? (
                        <Loader/>
                    ) :
                    ( <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table text-nowrap table-sm">
                                    <thead>
                                    <tr>
                                        <th scope="col">Amount Paid</th>
                                        <th scope="col">Date</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        history.length > 0 ? (
                                            history.map((data, index) => (
                                                <tr key={index}>
                                                    <th scope="row">
                                                        <div className="form-check">
                                                            <Link to={`/portal/payment/payment-receipt/${data.PaymentID}`} >
                                                            <label className="form-check-label" htmlFor="checkebox-sm">
                                                                {currencyConverter(data.AmountPaid)}
                                                            </label>
                                                            </Link>
                                                        </div>
                                                    </th>
                                                    <td><Link to={`/portal/payment/payment-receipt/${data.PaymentID}`} >{Date.parse(data.InsertedDate) ? formatDate(data.InsertedDate) : data.InsertedDate}</Link></td>
                                                    <td>
                                                        <div className="hstack gap-2 fs-15">
                                                            <Link to={`/portal/payment/payment-receipt/${data.PaymentID}`} className="btn btn-icon btn-sm btn-success"><i className="ti ti-file"></i></Link>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) :

                                            <tr>
                                                <td colSpan={3}><div className="alert alert-info text-center"><h3>No Record Found</h3></div></td>
                                            </tr>
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    )}
            </div>

        </div>


    );
};

const mapStateToProps = (state) => ({
    userData: state.paymentLoginDetails,
    paymentHistory: state.paymentHistoryData,
});

export default connect(mapStateToProps, null)(PaymentHistory);